<template>
  <span class="lk-badge" :style="style">
    <span v-if="dot" class="dot" :style="{ background: color }"></span>{{ resolvedLabel }}
  </span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    // 'active' | 'expired' | 'success' | 'warn' | 'danger' | custom label
    status: { type: String, default: 'active' },
    label: { type: String, default: '' },
    dot: { type: Boolean, default: false },
  },
  computed: {
    resolvedLabel() { return this.label || this.status; },
    color() {
      switch (this.status) {
        case 'active':
        case 'success': return 'var(--success)';
        case 'warn': return 'var(--warn)';
        case 'danger': return 'var(--danger)';
        default: return 'var(--faint)';
      }
    },
    bg() {
      switch (this.status) {
        case 'active':
        case 'success': return 'var(--success-soft)';
        case 'warn': return 'var(--warn-soft)';
        case 'danger': return 'var(--danger-soft)';
        default: return 'var(--surface)';
      }
    },
    style() { return { color: this.color, background: this.bg }; },
  },
};
</script>

<style scoped>
.dot { width: 6px; height: 6px; border-radius: 50%; }
</style>
